var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Playsquare = function Playsquare(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6Zm11.485 5.604a.5.5 0 0 1 0 .792l-3.18 2.448a.5.5 0 0 1-.805-.396V9.552a.5.5 0 0 1 .805-.396l3.18 2.448Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Playsquare;